import { render, staticRenderFns } from "./Myclass.vue?vue&type=template&id=5f395cf2&scoped=true&"
import script from "./Myclass.vue?vue&type=script&lang=js&"
export * from "./Myclass.vue?vue&type=script&lang=js&"
import style0 from "./Myclass.vue?vue&type=style&index=0&id=5f395cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f395cf2",
  null
  
)

export default component.exports